import '.d1{overflow:auto;}.ssr-plugin'
import '.n{position:relative;}.ssr-plugin'
import '.o{height:100%;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.et{min-width:240px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.a0{padding:16px;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.da{flex-direction:row;}.ssr-plugin'
import '.ae{justify-content:space-between;}.ssr-plugin'
import { ReactElement, ReactNode } from 'react'
import { Style, styled } from 'inlines'
import { Icon, IconProps } from '../Icon/index.js'
import { Separator } from '../Separator/index.js'
import { Stack } from '../Stack/index.js'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'

export const ActionList = (props: { items: ReactNode[]; style?: Style }) => {
  const { items, style } = props
  const separatedItems: ReactNode[] = []
  for (let index = 0; index < items.length; index++) {
    separatedItems.push(items[index])
    if (index < items.length - 1) {
      separatedItems.push(
        <Separator
          key={`separator-${(items[index] as ReactElement).key || index}`}
          orientation="horizontal"
          style={{ padding: '12px 0px 12px 0px', height: 1 }}
        />,
      )
    }
  }
  return (
    <styled.div className="d1 n o h et a a0 i"
      style={{
        borderRadius: radius[20],
        color: colors.neutral80,
        background: `linear-gradient(${colors.white5}),
          linear-gradient(${colors.neutralInverted100})`,
        boxShadow: `0px 8px 12px ${colors.black10}`,
        border: `1px ${colors.neutral10} solid`,
        ...style,
      }}
    >
      {separatedItems}
    </styled.div>
  )
}

export const ActionListItem = (props: {
  title?: string
  description?: string
  icon?: IconProps['variant']
  action?: ReactNode
}) => {
  const { title, description, action, icon } = props
  return (
    <div className="a da ae"
    >
      {icon && (
        <Icon
          variant={icon}
          size="regular"
          style={{
            minWidth: 32,
            minHeight: 32,
            padding: 4,
            borderRadius: radius[8],
            border: `1px solid ${colors.neutral20}`,
            background: `linear-gradient(180deg, transparent 0%, ${colors.neutral5} 100%)`,
            marginRight: 12,
            color: colors.neutral80,
          }}
        />
      )}
      <Stack grow direction="column" gap={2}>
        {title && (
          <Text variant="display-medium" color="neutral80">
            {title}
          </Text>
        )}
        {description && (
          <Text variant="display-regular" color="neutral60">
            {description}
          </Text>
        )}
      </Stack>
      {action && <div>{action}</div>}
    </div>
  )
}
